// Carousel photo partagé (paraphoto + single actualité).
// Transition wipe clip-path (GSAP), pager à points, autoplay avec pause au survol,
// défilement seulement quand le bloc est visible (IntersectionObserver).
// $bloc = objet jQuery contenant .pc-track > .pc-slide et .pc-dots.
function initPcCarousel($bloc) {

    var $track = $bloc.find(".pc-track");
    var $dots  = $bloc.find(".pc-dots");
    var slides = $track.find(".pc-slide").toArray();

    // Rien à faire tant qu'il n'y a pas au moins deux photos.
    if (slides.length < 2 || !$dots.length) return;

    var DELAY    = 5000; // défilement auto (ms)
    var DURATION = 0.8;  // durée du wipe clip-path (s)

    var current   = 0;
    var animating = false;
    var visible   = false;
    var timer     = null;

    // Applique le clip-path (avec préfixe) directement sur l'élément.
    // reveal = 0 -> photo masquée (rognée à droite), 100 -> pleinement révélée.
    function applyClip(el, reveal) {
        var value = "inset(0 " + (100 - reveal) + "% 0 0)";
        el.style.clipPath = value;
        el.style.webkitClipPath = value;
    }

    // État initial : toutes les photos révélées, seule l'active est au-dessus.
    slides.forEach(function(slide, i) {
        slide.style.zIndex = (i === 0 ? 1 : 0);
        applyClip(slide, 100);
    });

    // Montage des points (un bouton par photo).
    var dots = slides.map(function(slide, i) {
        var dot = document.createElement("button");
        dot.type = "button";
        dot.className = "pc-dot" + (i === 0 ? " is-active" : "");
        dot.setAttribute("role", "tab");
        dot.setAttribute("aria-label", "Photo " + (i + 1));
        dot.setAttribute("aria-selected", i === 0 ? "true" : "false");
        dot.addEventListener("click", function() { goToManual(i); });
        $dots[0].appendChild(dot);
        return dot;
    });

    // Le point actif grossit (le reste revient au repos), animé en GSAP.
    function setActiveDot(target) {
        dots.forEach(function(dot, i) {
            var isActive = (i === target);
            dot.classList.toggle("is-active", isActive);
            dot.setAttribute("aria-selected", isActive ? "true" : "false");
            gsap.to(dot, {
                scale: isActive ? 1.6 : 1,
                duration: 0.3,
                ease: "power2.out"
            });
        });
    }

    // Révèle la slide cible par un wipe horizontal (gauche -> droite).
    function goTo(target) {
        if (animating || target === current) return;
        animating = true;

        var incoming = slides[target];
        var outgoing = slides[current];

        incoming.style.zIndex = 2;
        outgoing.style.zIndex = 1;
        setActiveDot(target);

        // Wipe horizontal : on anime un proxy numérique et on réécrit le
        // clip-path à chaque frame (pas de dépendance au parseur de GSAP).
        applyClip(incoming, 0);
        var state = { reveal: 0 };

        gsap.to(state, {
            reveal: 100,
            duration: DURATION,
            ease: "power2.inOut",
            onUpdate: function() { applyClip(incoming, state.reveal); },
            onComplete: function() {
                outgoing.style.zIndex = 0;
                applyClip(outgoing, 100);
                incoming.style.zIndex = 1;
                current = target;
                animating = false;
            }
        });
    }

    function next() {
        goTo((current + 1) % slides.length);
    }

    // Action utilisateur : on va à la photo puis on relance le minuteur.
    function goToManual(target) {
        goTo(target);
        if (visible) start();
    }

    function start() {
        stop();
        timer = setInterval(function() {
            if (visible) next();
        }, DELAY);
    }

    function stop() {
        if (timer) {
            clearInterval(timer);
            timer = null;
        }
    }

    // Pause au survol du visuel comme du pager.
    $track.add($dots).on("mouseenter", stop).on("mouseleave", function() {
        if (visible) start();
    });

    // On ne défile que quand le bloc est réellement à l'écran.
    if ("IntersectionObserver" in window) {
        var io = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                visible = entry.isIntersecting;
                if (visible) { start(); } else { stop(); }
            });
        }, { threshold: 0.2 });
        io.observe($bloc[0]);
    } else {
        visible = true;
        start();
    }

}
